import { render } from "./WCAlertRoot.vue?vue&type=template&id=f65ece06"
import script from "./WCAlertRoot.vue?vue&type=script&lang=js"
export * from "./WCAlertRoot.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__